import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/img/transport/title.png'
import _imports_1 from '../../assets/img/transport/sxd.jpg'
import _imports_2 from '../../assets/img/transport/160000km.png'
import _imports_3 from '../../assets/img/transport/46000km.png'
import _imports_4 from '../../assets/img/transport/fast.png'
import _imports_5 from '../../assets/img/transport/add.png'
import _imports_6 from '../../assets/img/transport/safe.png'


const _hoisted_1 = { class: "transport-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createVNode("h2", null, "Transport"),
  /*#__PURE__*/_createVNode("div", { class: "img" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_3 = { class: "transport-list" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "item",
  style: {"padding":"30.5556vw 0 21.7593vw 14.3519vw"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "ani-img sxd-img line" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("p", null, "2024年8月30日"),
  /*#__PURE__*/_createVNode("p", null, "川青铁路镇江关至黄胜关段正式通车"),
  /*#__PURE__*/_createVNode("p", null, "成都到黄龙九寨最快只要99分钟"),
  /*#__PURE__*/_createVNode("p", null, "一条铁路串联了三星堆九寨沟大熊猫")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "item",
  style: {"padding":"35vw 0 19.4444vw 14.3519vw"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "ani-img km line" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_2,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ani-img km line" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_3,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("p", null, "目前"),
  /*#__PURE__*/_createVNode("p", null, "中国铁路总里程突破"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"6.6667vw","color":"#fe9200","line-height":"1","margin-bottom":"25.9259vw"} }, [
    /*#__PURE__*/_createVNode("b", null, "16万公里")
  ]),
  /*#__PURE__*/_createVNode("p", { style: {"width":"100%","box-sizing":"border-box","padding-right":"10.9259vw","text-align":"right"} }, "高铁里程近"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"6.6667vw","color":"#fe9200","line-height":"1","padding-right":"10.9259vw","text-align":"right"} }, [
    /*#__PURE__*/_createVNode("b", null, "4.6万公里")
  ]),
  /*#__PURE__*/_createVNode("p", { style: {"margin-top":"41.6667vw","font-size":"9.2593vw","font-weight":"bold","text-align":"center","color":"#c95245","line-height":"1","padding-right":"14.3519vw"} }, "稳居世界第一")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "item" }, [
  /*#__PURE__*/_createVNode("p", { style: {"color":"#b88d29"} }, "新中国成立75年来"),
  /*#__PURE__*/_createVNode("p", { style: {"color":"#b88d29"} }, "中国铁路从落后时代"),
  /*#__PURE__*/_createVNode("p", { style: {"color":"#b88d29"} }, "跟上时代"),
  /*#__PURE__*/_createVNode("p", { style: {"color":"#b88d29"} }, "再到引领时代"),
  /*#__PURE__*/_createVNode("p", { style: {"color":"#b88d29","margin-bottom":"16.6667vw"} }, "实现了历史性跨越"),
  /*#__PURE__*/_createVNode("p", { style: {"color":"#bd922c","font-size":"4.1667vw"} }, "曾经，中国人均铁路里程不足一根香烟长"),
  /*#__PURE__*/_createVNode("p", {
    class: "small-label",
    style: {"margin-left":"10vw"}
  }, "1949——2024中国铁路营业里程"),
  /*#__PURE__*/_createVNode("div", { class: "echarts" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "item",
  style: {"padding":"0 0 25vw 11.5741vw"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "ani-img fast-img line" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_4,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("p", { style: {"padding-right":"11.5741vw","text-align":"center","font-size":"6.6667vw","color":"#fe9200","margin-bottom":"12.037vw"} }, "现在中国铁路"),
  /*#__PURE__*/_createVNode("p", { class: "label" }, "全球速度最快"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "复兴号以350公里的时速“贴地飞行”"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "目前正攻坚商业运营"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "时速400公里新纪录"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"5.5556vw","color":"#fdb501","line-height":"1","font-family":"'TENSANS-BOLD'","margin-top":"16.6667vw","text-align":"center","padding-right":"11.5741vw"} }, "350Km/h"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"9.2593vw","color":"#fdb501","line-height":"1","font-family":"'TENSANS-BOLD'","margin":".9259vw 0 0 -7.8704vw"} }, "400Km/h")
], -1)
const _hoisted_8 = {
  class: "item",
  style: {"padding":"0 0 55.5556vw 11.5741vw"}
}
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "label" }, "全球运输最繁忙", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "高铁网覆盖96%的50万人口以上城市", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5","margin-bottom":"2.7778vw"} }, "一天运载旅客上千万人次", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"11.5741vw","padding-right":"11.5741vw","text-align":"center","color":"#fdb501","line-height":"1","font-family":"'TENSANS-BOLD'","margin-top":"31.4815vw"} }, [
  /*#__PURE__*/_createVNode("span", { class: "count-up" }, "96"),
  /*#__PURE__*/_createTextVNode("%")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", {
  class: "item",
  style: {"padding":"0 0 27.7778vw 11.5741vw"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "ani-img add-img line" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_5,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("p", { class: "label" }, "全球增势最明显"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "现代化铁路网"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "一年增长约3600公里"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "已建成"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5","color":"#fe9200"} }, "世界最发达的高铁网"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"9.2593vw","color":"#fdb501","line-height":"1","font-family":"'TENSANS-BOLD'","padding-right":"2.7778vw","margin-top":"7.8704vw","text-align":"right"} }, [
    /*#__PURE__*/_createTextVNode("+"),
    /*#__PURE__*/_createVNode("span", { class: "count-up" }, "3600"),
    /*#__PURE__*/_createTextVNode("KM")
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "item end-item" }, [
  /*#__PURE__*/_createVNode("div", { class: "ani-img safe-img line" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_6,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("p", { class: "label" }, "世界公认最安全"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "每天开行动车组列车8700多列"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "安全业绩遥遥领先"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"16.2037vw","color":"#fdb501","line-height":"1","font-family":"'TENSANS-BOLD'","margin":"32.8704vw 0 30.0926vw","padding-right":"11.5741vw","text-align":"center"} }, [
    /*#__PURE__*/_createVNode("span", { class: "count-up" }, "8700"),
    /*#__PURE__*/_createTextVNode("+")
  ]),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "目前"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "我国建成了世界上最大的高速铁路网"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "高速公路网"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "邮政快递网"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "世界级的港口群"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "智能化和数字化的运输服务"),
  /*#__PURE__*/_createVNode("p", { style: {"font-size":"4.4444vw","line-height":"1.5"} }, "越来越“聪明”、越来越“贴心”")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Circular = _resolveComponent("Circular")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _createVNode(_component_Circular),
        _hoisted_12
      ]),
      _hoisted_13,
      _hoisted_14
    ])
  ]))
}